// action - state management
import { REGISTER, LOGIN, LOGOUT, SKIP_INFO_COMPLETE, OPEN_INFO_COMPLETE } from './actions';

// types
import { AuthProps, AuthActionProps } from 'types/auth';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user, showInfoComplete } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        showInfoComplete
      };
    }
    case SKIP_INFO_COMPLETE: {
      return {
        ...state,
        showInfoComplete: false
      };
    }
    case OPEN_INFO_COMPLETE: {
      return {
        ...state,
        showInfoComplete: true
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
